module.exports = __webpack_public_path__ + "img/i-2.ae3e7eb1.svg";